import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AppConfigService } from '../../services/app-config.service';
import { LocalStorageService } from '../../shared';

@Component({
  selector: 'app-form-j',
  templateUrl: './app-form-j.component.html',
})
export class AppFormJComponent implements OnInit {
  public formName = 'rubrique_J_observations';

  /**
   * Taille max de la zone observations
   */
  observationsMaxLength = AppConfigService.settings.observationsMaxLength;
  form: FormGroup;
  items: FormArray;

  constructor(
    private formBuilder: FormBuilder,
    private localStorageService: LocalStorageService
  ) {}

  get formData() { return <FormArray>this.form.get('items'); }

  ngOnInit (): void {
    this.form = new FormGroup({
      j_observations: new FormControl(),
    });

    this.form = this.formBuilder.group({
      items: this.formBuilder.array([ this.createItem() ])
    });

    this.restoreFromStorage();

    // Auto-sauvegarder le brouillon du formulaire pendant la saisie
    this.form.valueChanges.subscribe(() => this.saveToStorage());
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      j_observations: '',
    });
  }

  /**
   * Sauvegarde le brouillon dans le localStorage.
   */
  private saveToStorage(): void {
    this.localStorageService.save('form_j', {
      values: this.formData.at(0).value
    });
  }

  /**
   * Restaure le brouillon depuis le localStorage.
   */
  private restoreFromStorage(): void {
    const saved = this.localStorageService.load('form_j');
    if (!saved) { return; }
    if (saved.values) {
      this.formData.at(0).patchValue(saved.values, { emitEvent: false });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-form-j/app-form-j.component.ts